<template>
  <div
    class="quiz-card shadow-sm footer-active"
    :class="slotFooter ? 'footer-active' : ''"
  >
    <div class="quiz-card__body">
      <div class="quiz-card__left">
        <div class="d-flex align-items-center">
          <svg
            class="mr-2"
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M31.5669 10.7525L27.5453 15.5338L20.5434 23.9062L16.4688 25.6488L17.5312 21.3456L25.8984 11.3475L28.5547 8.20781C28.6661 8.07502 28.8027 7.96554 28.9566 7.88563C29.1104 7.80573 29.2786 7.75697 29.4513 7.74217C29.624 7.72736 29.798 7.74679 29.9632 7.79935C30.1284 7.85191 30.2816 7.93655 30.4141 8.04844L31.4234 8.89312C31.6881 9.12128 31.8517 9.44487 31.8785 9.79324C31.9054 10.1416 31.7934 10.4865 31.5669 10.7525V10.7525Z"
              fill="#FFA88A"
            />
            <path
              d="M24.4375 6.28469V31.3438C24.4375 31.6255 24.3256 31.8958 24.1263 32.0951C23.927 32.2943 23.6568 32.4062 23.375 32.4062H3.1875C2.90571 32.4062 2.63546 32.2943 2.4362 32.0951C2.23694 31.8958 2.125 31.6255 2.125 31.3438V2.65625C2.125 2.37446 2.23694 2.10421 2.4362 1.90495C2.63546 1.70569 2.90571 1.59375 3.1875 1.59375H19.7466C19.8868 1.59364 20.0256 1.62128 20.1551 1.67507C20.2845 1.72887 20.4021 1.80775 20.5009 1.90719L24.1241 5.53031C24.2235 5.62916 24.3024 5.7467 24.3562 5.87617C24.41 6.00565 24.4376 6.14448 24.4375 6.28469V6.28469Z"
              fill="white"
            />
            <path
              d="M24.4374 10.625V21.7281L21.5209 25.2025L16.1446 27.5347C15.9636 27.6131 15.7643 27.6395 15.5691 27.611C15.3738 27.5826 15.1904 27.5003 15.0393 27.3735C14.8882 27.2466 14.7754 27.0802 14.7135 26.8929C14.6516 26.7056 14.6432 26.5047 14.689 26.3128L16.049 20.6072L24.4374 10.625ZM24.4374 6.28469V7.4375H19.6562C19.3744 7.4375 19.1041 7.32556 18.9049 7.1263C18.7056 6.92704 18.5937 6.65679 18.5937 6.375V1.59375H19.7465C19.8867 1.59364 20.0255 1.62128 20.155 1.67507C20.2845 1.72887 20.402 1.80775 20.5009 1.90719L24.124 5.53031C24.2234 5.62916 24.3023 5.7467 24.3561 5.87617C24.4099 6.00565 24.4375 6.14448 24.4374 6.28469V6.28469Z"
              fill="#E6E6E6"
            />
            <path
              d="M27.5453 15.5444L20.5434 23.9062L16.4688 25.6487L17.5312 21.3456L25.8984 11.3475C26.7881 12.5876 27.3542 14.0302 27.5453 15.5444V15.5444Z"
              fill="#FE8C90"
            />
            <path
              d="M20.1875 1.59375V5.84375H24.4375L20.1875 1.59375Z"
              fill="#678BE2"
            />
            <path
              d="M31.5669 10.7525L30.2812 12.2666L27.2531 9.72187L28.5228 8.20781C28.6343 8.07502 28.7708 7.96554 28.9247 7.88563C29.0786 7.80573 29.2467 7.75697 29.4194 7.74217C29.5922 7.72736 29.7661 7.74679 29.9313 7.79935C30.0965 7.85191 30.2498 7.93655 30.3822 8.04844L31.3916 8.89312C31.6609 9.11678 31.8305 9.43807 31.8634 9.78659C31.8963 10.1351 31.7896 10.4824 31.5669 10.7525V10.7525ZM11.6875 7.4375H17.5312C17.6721 7.4375 17.8073 7.38153 17.9069 7.2819C18.0065 7.18227 18.0625 7.04715 18.0625 6.90625C18.0625 6.76535 18.0065 6.63023 17.9069 6.5306C17.8073 6.43097 17.6721 6.375 17.5312 6.375H11.6875C11.5466 6.375 11.4115 6.43097 11.3118 6.5306C11.2122 6.63023 11.1562 6.76535 11.1562 6.90625C11.1562 7.04715 11.2122 7.18227 11.3118 7.2819C11.4115 7.38153 11.5466 7.4375 11.6875 7.4375ZM11.1562 13.8125H20.7188C20.8596 13.8125 20.9948 13.7565 21.0944 13.6569C21.194 13.5573 21.25 13.4221 21.25 13.2812C21.25 13.1404 21.194 13.0052 21.0944 12.9056C20.9948 12.806 20.8596 12.75 20.7188 12.75H11.1562C11.0154 12.75 10.8802 12.806 10.7806 12.9056C10.681 13.0052 10.625 13.1404 10.625 13.2812C10.625 13.4221 10.681 13.5573 10.7806 13.6569C10.8802 13.7565 11.0154 13.8125 11.1562 13.8125Z"
              fill="#678BE2"
            />
            <path
              d="M15.4062 19.6562C15.4062 19.5154 15.3503 19.3802 15.2507 19.2806C15.151 19.181 15.0159 19.125 14.875 19.125H11.1562C11.0154 19.125 10.8802 19.181 10.7806 19.2806C10.681 19.3802 10.625 19.5154 10.625 19.6562C10.625 19.7971 10.681 19.9323 10.7806 20.0319C10.8802 20.1315 11.0154 20.1875 11.1562 20.1875H14.875C15.0159 20.1875 15.151 20.1315 15.2507 20.0319C15.3503 19.9323 15.4062 19.7971 15.4062 19.6562Z"
              fill="#FE8C90"
            />
            <path
              d="M9.03125 17.5312H5.84375C5.70285 17.5312 5.56773 17.5872 5.4681 17.6868C5.36847 17.7865 5.3125 17.9216 5.3125 18.0625V21.25C5.3125 21.3909 5.36847 21.526 5.4681 21.6257C5.56773 21.7253 5.70285 21.7812 5.84375 21.7812H9.03125C9.17215 21.7812 9.30727 21.7253 9.4069 21.6257C9.50653 21.526 9.5625 21.3909 9.5625 21.25V18.0625C9.5625 17.9216 9.50653 17.7865 9.4069 17.6868C9.30727 17.5872 9.17215 17.5312 9.03125 17.5312ZM8.5 20.7188H6.375V18.5938H8.5V20.7188Z"
              fill="#678BE2"
            />
            <path
              d="M13.2812 25.5H11.1562C11.0154 25.5 10.8802 25.556 10.7806 25.6556C10.681 25.7552 10.625 25.8904 10.625 26.0312C10.625 26.1721 10.681 26.3073 10.7806 26.4069C10.8802 26.5065 11.0154 26.5625 11.1562 26.5625H13.2812C13.4221 26.5625 13.5573 26.5065 13.6569 26.4069C13.7565 26.3073 13.8125 26.1721 13.8125 26.0312C13.8125 25.8904 13.7565 25.7552 13.6569 25.6556C13.5573 25.556 13.4221 25.5 13.2812 25.5Z"
              fill="#FE8C90"
            />
            <path
              d="M9.03125 23.9062H5.84375C5.70285 23.9062 5.56773 23.9622 5.4681 24.0618C5.36847 24.1615 5.3125 24.2966 5.3125 24.4375V27.625C5.3125 27.7659 5.36847 27.901 5.4681 28.0007C5.56773 28.1003 5.70285 28.1562 5.84375 28.1562H9.03125C9.17215 28.1562 9.30727 28.1003 9.4069 28.0007C9.50653 27.901 9.5625 27.7659 9.5625 27.625V24.4375C9.5625 24.2966 9.50653 24.1615 9.4069 24.0618C9.30727 23.9622 9.17215 23.9062 9.03125 23.9062ZM8.5 27.0938H6.375V24.9688H8.5V27.0938Z"
              fill="#678BE2"
            />
            <path
              d="M7.06041 15.2522C7.11005 15.3014 7.16892 15.3404 7.23364 15.3668C7.29837 15.3933 7.36768 15.4067 7.43759 15.4062H7.52259C7.60529 15.3924 7.68353 15.3592 7.75094 15.3094C7.81834 15.2595 7.87299 15.1944 7.91041 15.1194L9.50416 11.9319C9.54182 11.8693 9.56617 11.7996 9.57569 11.7272C9.5852 11.6547 9.57967 11.5811 9.55945 11.5109C9.53922 11.4407 9.50474 11.3754 9.45815 11.3192C9.41156 11.2629 9.35386 11.2168 9.28867 11.1839C9.22347 11.1509 9.15218 11.1318 9.07925 11.1276C9.00631 11.1234 8.9333 11.1343 8.86478 11.1597C8.79626 11.185 8.73369 11.2242 8.681 11.2748C8.62831 11.3254 8.58662 11.3863 8.55853 11.4537L7.29416 13.9825L6.23166 12.92C6.18212 12.8705 6.12332 12.8312 6.0586 12.8044C5.99388 12.7776 5.92452 12.7638 5.85447 12.7638C5.78442 12.7638 5.71505 12.7776 5.65034 12.8044C5.58562 12.8312 5.52681 12.8705 5.47728 12.92C5.42775 12.9695 5.38846 13.0283 5.36165 13.0931C5.33484 13.1578 5.32104 13.2271 5.32104 13.2972C5.32104 13.3672 5.33484 13.4366 5.36165 13.5013C5.38846 13.566 5.42775 13.6248 5.47728 13.6744L7.06041 15.2522ZM7.06041 8.87719C7.11005 8.92642 7.16892 8.96538 7.23364 8.99182C7.29837 9.01825 7.36768 9.03165 7.43759 9.03125H7.52259C7.60529 9.01743 7.68353 8.98423 7.75094 8.93437C7.81834 8.88451 7.87299 8.8194 7.91041 8.74437L9.50416 5.55688C9.54182 5.49428 9.56617 5.42459 9.57569 5.35216C9.5852 5.27972 9.57967 5.20611 9.55945 5.13591C9.53922 5.06571 9.50474 5.00044 9.45815 4.94417C9.41156 4.8879 9.35386 4.84184 9.28867 4.80888C9.22347 4.77592 9.15218 4.75675 9.07925 4.75259C9.00631 4.74842 8.9333 4.75935 8.86478 4.78467C8.79626 4.81 8.73369 4.84919 8.681 4.89979C8.62831 4.95039 8.58662 5.01131 8.55853 5.07875L7.29416 7.6075L6.23166 6.545C6.13162 6.44496 5.99594 6.38876 5.85447 6.38876C5.713 6.38876 5.57732 6.44496 5.47728 6.545C5.37725 6.64504 5.32104 6.78071 5.32104 6.92219C5.32104 7.06366 5.37725 7.19934 5.47728 7.29938L7.06041 8.87719Z"
              fill="#FE8C90"
            />
            <path
              d="M20.5434 23.8903L16.4846 25.6488L17.5099 21.3456L20.5434 23.8903Z"
              fill="white"
            />
            <path
              d="M32.4062 9.74313C32.3843 9.5026 32.3148 9.26883 32.2017 9.05542C32.0886 8.84201 31.9342 8.65321 31.7475 8.5L30.7328 7.65C30.3572 7.33535 29.8721 7.18267 29.384 7.2255C28.8959 7.26833 28.4447 7.50318 28.1297 7.87844L26.8547 9.3925L24.9688 11.6344V6.28469C24.9684 5.86214 24.8002 5.45704 24.5012 5.15844L20.8728 1.53C20.5742 1.23103 20.1691 1.06287 19.7466 1.0625H3.1875C2.76481 1.0625 2.35943 1.23041 2.06055 1.5293C1.76166 1.82818 1.59375 2.23356 1.59375 2.65625V31.3438C1.59375 31.7664 1.76166 32.1718 2.06055 32.4707C2.35943 32.7696 2.76481 32.9375 3.1875 32.9375H23.375C23.7977 32.9375 24.2031 32.7696 24.502 32.4707C24.8008 32.1718 24.9688 31.7664 24.9688 31.3438V19.4437L31.9759 11.0925C32.1328 10.9069 32.2516 10.6922 32.3254 10.4607C32.3993 10.2291 32.4267 9.98529 32.4062 9.74313V9.74313ZM20.7188 2.87406L23.1572 5.3125H20.7188V2.87406ZM23.9062 31.3438C23.9062 31.4846 23.8503 31.6198 23.7507 31.7194C23.651 31.819 23.5159 31.875 23.375 31.875H3.1875C3.0466 31.875 2.91148 31.819 2.81185 31.7194C2.71222 31.6198 2.65625 31.4846 2.65625 31.3438V2.65625C2.65625 2.51535 2.71222 2.38023 2.81185 2.2806C2.91148 2.18097 3.0466 2.125 3.1875 2.125H19.6562V5.84375C19.6562 5.98465 19.7122 6.11977 19.8118 6.2194C19.9115 6.31903 20.0466 6.375 20.1875 6.375H23.9062V12.75C23.9016 12.7906 23.9016 12.8316 23.9062 12.8722L17.1063 21.0056C17.0556 21.0637 17.0192 21.1328 17 21.2075C17 21.2075 17 21.2075 17 21.2075L15.9747 25.5106C15.9516 25.6067 15.9558 25.7073 15.9868 25.8012C16.0177 25.895 16.0743 25.9784 16.15 26.0419C16.2448 26.123 16.3652 26.1681 16.49 26.1694C16.5628 26.1681 16.6348 26.1537 16.7025 26.1269L20.7613 24.3631C20.8351 24.3305 20.9005 24.2814 20.9525 24.2197L23.9062 20.7188V31.3438ZM17.8288 22.3125L19.5447 23.7522L17.2497 24.7509L17.8288 22.3125ZM20.485 23.1519L18.2644 21.2925L27.3275 10.4709L29.5481 12.3356L20.485 23.1519ZM31.1631 10.4019L30.2281 11.5175L28.0128 9.65813L28.9425 8.54781C29.0776 8.38872 29.27 8.28941 29.478 8.2715C29.6859 8.25359 29.8925 8.31853 30.0528 8.45219L31.0622 9.30219C31.2213 9.43727 31.3206 9.62972 31.3385 9.83766C31.3564 10.0456 31.2915 10.2522 31.1578 10.4125L31.1631 10.4019Z"
              fill="#4E5B5F"
            />
          </svg>

          <p class="text mb-0">
            <small class="d-block text-muted ">Deneme Adı</small>
            <strong>{{ exam.translate.title }}</strong>
          </p>
        </div>
        <slot name="headerRight"></slot>
      </div>

      <div class="quiz-card__right justify-content-around">
        <slot name="quizCardRight"></slot>

        <span class="fw-600 text-gray-dark" v-if="exam.user_result">
          Deneme Puanı:
          <span class="text-primary">{{
            exam.user_result.grade % 1 === 0
              ? parseInt(exam.user_result.grade)
              : exam.user_result.grade
          }}</span>
          PUAN
        </span>

        <div class="w-50" v-if="exam.user_result && exam.without_session">
          <button
            class="btn btn-primary btn-with-ico shadow-sm header-btn w-100"
            @click="examRetry(exam)"
          >
            <span class="ico bg-white">
              <i class="icon-penline text-black-50"></i>
            </span>
            <span class="text">Tekrar Çöz</span>
          </button>
        </div>
      </div>
    </div>

    <div class="quiz-card__footer" v-if="exam.user_result">
      <div class="left">
        <details :open="false">
          <summary>Deneme Raporu</summary>
          <div class="quiz-result-grid py-3">
            <div class="">
              <span class="result-title">Soru Sayısı</span>
              <span class="result-text"
                ><strong>{{ exam.user_result.total }}</strong></span
              >
            </div>

            <div class="">
              <span class="result-title">Süre</span>
              <span class="result-text"
                ><strong>{{ exam.exam_duration }}</strong></span
              >
            </div>

            <div class="">
              <span class="result-title success">Doğru</span>
              <span class="result-text"
                ><strong>{{ exam.user_result.correct }}</strong
                >/{{ exam.user_result.total }}</span
              >
            </div>

            <div class="">
              <span class="result-title unsuccess">Yanlış</span>
              <span class="result-text"
                ><strong>{{ exam.user_result.wrong }}</strong
                >/{{ exam.user_result.total }}</span
              >
            </div>

            <div class="">
              <span class="result-title empty">Boş</span>
              <span class="result-text"
                ><strong>{{ exam.user_result.unanswered }}</strong
                >/{{ exam.user_result.total }}</span
              >
            </div>

            <div class="">
              <span class="result-title">Deneme Sonucu</span>
              <strong class="text-gray-dark"
                >{{
                  exam.user_result.grade % 1 === 0
                    ? parseInt(exam.user_result.grade)
                    : exam.user_result.grade
                }}
                Puan</strong
              >
            </div>

            <div class="">
              <span class="result-title">Harcanan Süre</span>
              <strong class="text-gray-dark">{{
                this.$root.getSecondFormat(
                  exam.user_result.spended_time,
                  ':h saat :m dakika',
                )
              }}</strong>
            </div>
          </div>

          <details class="mb-30" @toggle="toggleResultArea">
            <summary>Cevap Anahtarı</summary>

            <template
              v-if="
                typeof userResult.loading === 'boolean' && userResult.loading
              "
            >
              <ul class="nav tab-menu--primary quiz-tabMenu">
                <li class="nav-item">
                  <button
                    class="nav-link"
                    @click="changeQuestionFilter(undefined)"
                    :class="{
                      active: this.userResult.questionFilter === undefined,
                    }"
                  >
                    Tümü ({{ userResult.questions.length }})
                  </button>
                </li>

                <li class="nav-item">
                  <button
                    class="nav-link"
                    @click="changeQuestionFilter('correct')"
                    :class="{
                      active: this.userResult.questionFilter === 'correct',
                    }"
                  >
                    Doğru
                    <span class="text-green fw-500"
                      >({{ getFilteredQuestionsCount('correct') }})</span
                    >
                  </button>
                </li>

                <li class="nav-item">
                  <button
                    class="nav-link"
                    @click="changeQuestionFilter('wrong')"
                    :class="{
                      active: this.userResult.questionFilter === 'wrong',
                    }"
                  >
                    Yanlış
                    <span class="text-red fw-500"
                      >({{ getFilteredQuestionsCount('wrong') }})</span
                    >
                  </button>
                </li>

                <li class="nav-item">
                  <button
                    class="nav-link"
                    @click="changeQuestionFilter('empty')"
                    :class="{
                      active: this.userResult.questionFilter === 'empty',
                    }"
                  >
                    Boş
                    <span class="text-gray-dark fw-500"
                      >({{ getFilteredQuestionsCount('empty') }})</span
                    >
                  </button>
                </li>
              </ul>

              <vue-scroll class="question-numbers mt-3" :ops="ops">
                <li
                  class="question-number"
                  v-for="(question, index) in filteredQuestions"
                  @click.prevent="setQuestionActive(question.id)"
                  :key="question.id"
                  :class="{
                    unsuccess: question.user_answer_status === 'wrong',
                    success: question.user_answer_status === 'correct',
                    empty: question.user_answer_status === 'empty',
                  }"
                >
                  {{ question.index + 1 }}
                </li>
              </vue-scroll>

              <hr class="my-3" />

              <div
                class="question-box"
                v-for="question in userResult.questions"
                :key="question.id"
                :class="{ show: isQuestionActive(question.id) }"
              >
                <div class="question-detail-card mb-3">
                  <div
                    class="detail-card__header d-flex align-items-center justify-content-between mb-3"
                  >
                    <span
                      class="question-number"
                      :class="{
                        unsuccess: question.user_answer_status === 'wrong',
                        success: question.user_answer_status === 'correct',
                        empty: question.user_answer_status === 'empty',
                      }"
                      >{{ question.index + 1 }}</span
                    >

                    <div class="question-category" v-if="question.gains.length">
                      Bu bir
                      <span class="text-primary fw-500">{{
                        question.gains[0].translate.title
                      }}</span>
                      sorusudur.
                    </div>
                  </div>

                  <div class="2">
                    <p v-math v-html="replaceQuestionBlanks(question)"></p>

                    <div
                      class="question-explain-card mb-3"
                      v-if="question.solution"
                    >
                      <p class="mb-0" v-math v-html="question.solution.content"></p>
                    </div>
                  </div>
                </div>

                <div class="question-options-card">
                  <ul class="question-options">
                    <li
                      class="option"
                      :class="{
                        success: question.correct_answer_id === answer.id,
                        unsuccess:
                          question.correct_answer_id !== answer.id &&
                          getMyAnswer(question.id) &&
                          getMyAnswer(question.id).answer_id === answer.id,
                      }"
                      v-for="(answer, index) in question.answers"
                      :key="answer.id"
                    >
                      <span class="left">{{
                        getQuestionAnswerLabel(index)
                      }}</span>
                      <span
                        class="center"
                        v-math
                        v-html="answer.translate.content"
                      ></span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="text-center mt-3 mb-3">
                <b>Sınav sonuçlarınızı yüklerken lütfen bekleyiniz..</b>
              </div>
            </template>
          </details>

          <details class="" @toggle="toggleResultArea">
            <summary>Soru Tipi Analizi</summary>

            <template
              v-if="
                typeof userResult.loading === 'boolean' && userResult.loading
              "
            >
              <div class="question-type mt-3">
                <div class="question-type-item first fw-700">SORU TİPİ</div>
                <div class="question-type-item fw-700">HARCADIĞIM SÜRE</div>
                <div class="question-type-item fw-700">SORU SAYISI</div>
                <div class="question-type-item text-green fw-700">
                  DOĞRU SAYISI
                </div>
                <div class="question-type-item text-red fw-700">
                  YANLIŞ SAYISI
                </div>
                <div class="question-type-item last text-gray-soft fw-700">
                  BOŞ SAYISI
                </div>

                <template v-for="analyze in userResult.analyzedQuestions">
                  <div class="question-type-item first fw-500">
                    {{ analyze.title }}
                  </div>
                  <div class="question-type-item fw-500 text-green">
                    {{
                      analyze.statistics.spendedTime
                        ? $root.getSecondFormat(
                            analyze.statistics.spendedTime,
                            ':m dk. :s sn.',
                          )
                        : '-'
                    }}
                  </div>
                  <div class="question-type-item fw-500">
                    {{ analyze.statistics.total }}
                  </div>
                  <div class="question-type-item fw-500">
                    {{ analyze.statistics.correct }}
                  </div>
                  <div class="question-type-item fw-500">
                    {{ analyze.statistics.wrong }}
                  </div>
                  <div class="question-type-item fw-500 last">
                    {{ analyze.statistics.empty }}
                  </div>
                </template>
              </div>
            </template>

            <template v-else>
              <div class="text-center mt-3 mb-3">
                <b>Sınav sonuçlarınızı yüklerken lütfen bekleyiniz..</b>
              </div>
            </template>
          </details>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import EventBus from '../event-bus';

export default {
  data() {
    return {
      slotFooter: this.$slots.footer,
      userResult: {
        loading: undefined,
        result: {},
        questions: [],
        answers: [],
        questionFilter: undefined,
        activeQuestionId: undefined,
        analyzedQuestions: {},
      },
      ops: {
        rail: {
          enable: false,
        },
        bar: {
          enable: false,
        },
        scrollButton: {
          enable: false,
        },
        scrollPanel: {
          easing: 'easeInQuad',
          speed: 800,
        },
        vuescroll: {
          wheelScrollDuration: 0,
          wheelDirectionReverse: true,
        },
      },
    };
  },
  props: {
    exam: Object,
  },
  methods: {
    toggleResultArea({ target }) {
      if (target.open && typeof this.userResult.loading === 'undefined') {
        this.getUserResult();
      }
    },
    getUserResult() {
      this.userResult.loading = true;

      axios.get('/module/exam/result/' + this.exam.id).then((response) => {
        if (response.data.status) {
          this.userResult.result = response.data.data.result;
          this.userResult.questions = response.data.data.questions;
          this.userResult.answers = response.data.data.answers;

          if (this.userResult.questions.length) {
            if (typeof this.userResult.activeQuestionId === 'undefined') {
              this.userResult.activeQuestionId = this.userResult.questions[0].id;
            }

            this.analyzeQuestions();
          }
        } else {
          this.userResult.loading = undefined;
        }
      });
    },
    analyzeQuestions() {
      let questionsGroupedGains = {};

      this.userResult.questions.forEach((question, index) => {
        question.index = index;

        if (question.gains_count) {
          if (!questionsGroupedGains.hasOwnProperty(question.gains[0].id)) {
            questionsGroupedGains[question.gains[0].id] = {
              id: question.gains[0].id,
              title:
                question.gains[0].translate &&
                question.gains[0].translate.title,
              statistics: {
                spendedTime: 0,
                total: 0,
                correct: 0,
                wrong: 0,
                empty: 0,
              },
            };
          }

          questionsGroupedGains[question.gains[0].id].statistics.total++;

          if (question.user_answer_status === 'correct') {
            questionsGroupedGains[question.gains[0].id].statistics.correct++;
          } else if (question.user_answer_status === 'wrong') {
            questionsGroupedGains[question.gains[0].id].statistics.wrong++;
          } else if (question.user_answer_status === 'empty') {
            questionsGroupedGains[question.gains[0].id].statistics.empty++;
          }

          questionsGroupedGains[
            question.gains[0].id
          ].statistics.spendedTime += this.getQuestionSpendedTime(question.id);
        }
      });

      this.userResult.analyzedQuestions = questionsGroupedGains;
    },
    isQuestionActive(id) {
      return this.userResult.activeQuestionId === id;
    },
    setQuestionActive(id) {
      this.userResult.activeQuestionId = id;
    },
    changeQuestionFilter(filter) {
      this.userResult.activeQuestionId = undefined;
      this.userResult.questionFilter = filter;
    },
    getFilteredQuestionsCount(filter) {
      return this.userResult.questions.filter(
        (question) => question.user_answer_status === filter,
      ).length;
    },
    getMyAnswer(question_id) {
      let find = this.userResult.answers.filter(
        (answer) => answer.question_id === question_id,
      );
      return find.length ? find[0] : undefined;
    },
    getQuestionAnswerLabel(index) {
      let characters = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'R',
        'S',
        'T',
        'U',
        'V',
        'Y',
        'Z',
      ];
      return characters[index];
    },
    getQuestionSpendedTime(question_id) {
      let spendedTime = 0;

      this.userResult.questions.forEach((question, index) => {
        if (question.id === question_id && question.user_answered) {
          if (index === 0) {
            if (
              this.userResult.result &&
              this.userResult.result.user_session &&
              this.userResult.result.user_session.start_date
            ) {
              spendedTime = moment
                .duration(
                  moment(question.user_answer_date).diff(
                    moment(this.userResult.result.user_session.start_date),
                  ),
                )
                .asSeconds();
            }
          } else {
            let previousAnswerDate = this.userResult.questions.at(index - 1)
              .user_answer_date;

            if (previousAnswerDate) {
              spendedTime = moment
                .duration(
                  moment(question.user_answer_date).diff(
                    moment(previousAnswerDate),
                  ),
                )
                .asSeconds();
            }
          }
        }
      });

      if (spendedTime < 1) {
        spendedTime = 0;
      }

      return spendedTime;
    },
    replaceQuestionBlanks(questionsContent) {
      let filledBlanks;
      let answerSplit = '';

      if (questionsContent.id === this.userResult.activeQuestionId) {
        let title = questionsContent.answers.filter((answer) => {
          return questionsContent.correct_answer_id === answer.id;
        });

        if (!title.length) {
          return (
            questionsContent.translate && questionsContent.translate.content
          );
        }

        let temp = document.createElement('p');
        temp.innerHTML = title[0].translate && title[0].translate.content;

        answerSplit = temp.innerText.split('/');

        filledBlanks = questionsContent.translate.content.replace(
          /----/g,
          '<span class="text-success blanko">----</span>',
        );

        setTimeout(() => {
          let blanks = document.querySelectorAll('.blanko');

          blanks.forEach((item, index) => {
            blanks[index].innerHTML = answerSplit[index];
          });
        }, 500);
      }

      return filledBlanks;
    },
    examRetry(exam) {
      if (!exam.without_session) {
        return false;
      }

      if (!(exam.sessions && exam.sessions[0])) {
        return false;
      }

      EventBus.$emit('exam_retry_join', exam.sessions[0]);
    },
  },
  computed: {
    filteredQuestions() {
      if (!this.userResult.questionFilter) {
        return this.userResult.questions;
      }

      return this.userResult.questions.filter(
        (question) =>
          question.user_answer_status === this.userResult.questionFilter,
      );
    },
  },
  watch: {
    'userResult.questionFilter': {
      handler(newValue, oldValue) {
        if (
          this.userResult.activeQuestionId === undefined &&
          this.filteredQuestions.length
        ) {
          this.userResult.activeQuestionId = this.filteredQuestions.at(0).id;
        }
      },
      deep: true,
    },
  },
};
</script>
